export default "__VITE_ASSET__CWuSHIAm__"